import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiArchive, FiRefreshCw } from 'react-icons/fi';
import './RemovedListingOptionsDialog.css';

const RemovedListingOptionsDialog = ({
    open,
    listingTitle,
    busyAction = null,
    onRelist,
    onMoveToCollection,
    onDismiss,
}) => {
    useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = (event) => {
            if (event.key === 'Escape' && !busyAction) onDismiss?.();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [open, busyAction, onDismiss]);

    if (!open) return null;

    const busy = !!busyAction;

    return createPortal(
        <div className="msv-confirm-overlay" role="presentation" onClick={() => !busy && onDismiss?.()}>
            <div
                className="msv-removed-options-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="msv-removed-options-title"
                aria-describedby="msv-removed-options-message"
                onClick={(event) => event.stopPropagation()}
            >
                <h3 id="msv-removed-options-title">Listing paused</h3>
                <p id="msv-removed-options-message">
                    What would you like to do with <strong>{listingTitle}</strong>?
                </p>
                <div className="msv-removed-options-actions">
                    <button
                        type="button"
                        className="msv-removed-option msv-removed-option--relist"
                        onClick={onRelist}
                        disabled={busy}
                    >
                        <FiRefreshCw aria-hidden />
                        {busyAction === 'relist' ? 'Relisting…' : 'Relist for 30 days'}
                    </button>
                    <button
                        type="button"
                        className="msv-removed-option msv-removed-option--collection"
                        onClick={onMoveToCollection}
                        disabled={busy}
                    >
                        <FiArchive aria-hidden />
                        {busyAction === 'collection' ? 'Deleting…' : 'Keep in collection only'}
                    </button>
                </div>
                <button
                    type="button"
                    className="msv-removed-options-dismiss"
                    onClick={onDismiss}
                    disabled={busy}
                >
                    Not now
                </button>
            </div>
        </div>,
        document.body
    );
};

export default RemovedListingOptionsDialog;
